<template>
    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
            <a-form-item label="项目名称" name="projectName">
                <a-input v-model:value="searchForm.projectName" placeholder="请输入项目名称"/>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>
        <!-- <div class="table-toolbar">
            <a-button type="primary" @click="onAdd">
                <template #icon>
                    <plus-outlined/>
                </template>
                新增
            </a-button>
            <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)" v-if="selectedRowKeys.length">
                <a-button danger>批量删除</a-button>
            </a-popconfirm>
        </div> -->
        <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
            <template #message>
                已选择 {{ selectedRowKeys.length }} 项
                <a @click="onClearSelected" class="ml-20 float-right">清空</a>
            </template>
        </a-alert>
        <a-table
            :columns="columns"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">
            <template #action="{record}">
                <div class="table-row-operations">
                    <!--                    <a @click="onStateus(record)">服务状态修改</a>-->
                    <a @click="onEdit(record)">编辑</a>
                </div>
            </template>
        </a-table>
    </a-card>
    <AddOrEditModal ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
</template>

<script>
import AddOrEditModal from "./components/AddOrEditModal";
import {tableListMixin} from "@/mixins";
import {financeDocking} from "@/api/finance";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "项目名称", dataIndex: "projectName", key: "projectName"},
    {title: "投机机构/投资人", dataIndex: "senderName", key: "senderName"},
    {title: "投资经理", dataIndex: "investorManager", key: "InvestorManager"},
        {title: "联系方式", dataIndex: "senderContactNumber", key: "senderContactNumber"},
        {title: "对接备注", dataIndex: "notes", key: "notes"},
        {title: "对接时间", dataIndex: "createdTime", key: "createdTime"},
        // {title: "操作", fixed:'right', dataIndex: "action", key: "action", slots: {customRender: "action"}},
];
export default {
    name: "投资对接",
    mixins: [tableListMixin],
    components: {
        AddOrEditModal
    },
    data() {
        return {
            columns,
            queryParam: {dockingType:3,senderId:this.$ls.get('notificationId')},
            listUrl: financeDocking.pageList,
            listKeyField: "id",
            // deleteUrl: financeDocking.remove
        }
    },
    methods: {
        onAdd() {
            this.onShowModal('modal');
        },
        onEdit(record) {
            this.getAction({
                url: financeDocking.detail,
                params: {id: record.id}
            }).then(res => {
                this.onShowModal('modal', res);
            })
        },
    }
}
</script>

<style scoped>

</style>
